const INITIATIVE_TYPE_OPTIONS = [
  { value: "new purchase", label: "New Purchase" },
  { value: "replace tool", label: "Replace Tool" },
  { value: "other", label: "Other" },
];

const INITIATIVE_TYPE_LABELS: Record<string, string> = {
  "new purchase": "New Purchase",
  "replace tool": "Replace Tool",
  other: "Other",
};

export interface InitiativesFilterValues {
  title: string;
  type: string;
  visibility: string;
}

const INITIAL_INITIATIVES_FILTER_VALUES: InitiativesFilterValues = {
  title: "",
  type: "",
  visibility: "",
};

function getInitiativeTypeDisplayLabel(type: string) {
  return INITIATIVE_TYPE_LABELS[type?.toLowerCase()] || type || "-";
}

function formatTargetCompletion(value: string) {
  if (value === "over_1_year") return "Over 1 year";
  if (!value) return "-";

  const [year, month] = value.split("-");
  if (!year || !month) return value;

  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}

function normalizeInitiativesFilterValues(
  filters: InitiativesFilterValues
): InitiativesFilterValues {
  return {
    title: (filters.title ?? "").trim(),
    type: filters.type ?? "",
    visibility: filters.visibility ?? "",
  };
}

function getHasActiveInitiativesFilters(filters: InitiativesFilterValues) {
  return (
    Boolean(filters.title?.trim()) ||
    Boolean(filters.type) ||
    Boolean(filters.visibility)
  );
}

function filterInitiatives<T extends { title?: string; type?: string; isPublic?: boolean }>(
  list: T[],
  filters: InitiativesFilterValues
): T[] {
  return list.filter((item) => {
    if (filters.title) {
      const titleMatch = (item.title ?? "")
        .toLowerCase()
        .includes(filters.title.toLowerCase());
      if (!titleMatch) return false;
    }
    if (filters.type) {
      if ((item.type ?? "").toLowerCase() !== filters.type.toLowerCase()) {
        return false;
      }
    }
    if (filters.visibility === "public" && !item.isPublic) return false;
    if (filters.visibility === "private" && item.isPublic) return false;
    return true;
  });
}

export {
  INITIATIVE_TYPE_OPTIONS,
  INITIAL_INITIATIVES_FILTER_VALUES,
  getInitiativeTypeDisplayLabel,
  formatTargetCompletion,
  normalizeInitiativesFilterValues,
  getHasActiveInitiativesFilters,
  filterInitiatives,
};
